export type TVarCategory = 'LOW' | 'MEDIUM' | 'HIGH';

const VarCategories: Record<TVarCategory, string> = {
  LOW: 'varCategories.low',
  MEDIUM: 'varCategories.medium',
  HIGH: 'varCategories.high'
};

export const VarCategoriesOptions = (Object.keys(VarCategories) as TVarCategory[]).map(
  (key: TVarCategory) => {
    return { value: key, key, label: VarCategories[key] };
  }
);

export default VarCategories;
